import * as transform           from '../../lib/transform'
import actionTypes              from '../../constants/actionTypes'
import { getLeagues, getScoreboard }  from './index'
import selectn                  from 'selectn'
import dateFormat               from '../../lib/utils/dateformat'

const DAY_IN_MILLISECONDS = 86400000  // 1 day in milliseconds

function getAltDates( minRange = 0, scoreboardRes = {} ) {

  const calendar  = selectn('data.leagues[0].calendar',scoreboardRes) || []
  const calLen  = calendar.length || 0
  const maxRange  = minRange + (DAY_IN_MILLISECONDS * 6)
  let altDates  = []

  for (let i = 0; i < calLen; i++) {
    const dateObj = dateFormat.dateToObject( calendar[i] ) || new Date()
    const epochTime = dateObj.setHours(0,0,0,0)
    if(epochTime >= minRange && epochTime < maxRange) {
      altDates.push(dateFormat.dateToKey(epochTime))
    }
  }
  return altDates
}

function getDisplayDate( paramDate = '', scoreboardRes = {} ) {
  
  const calendar  = selectn('data.leagues[0].calendar',scoreboardRes) || []
  const calLen  = calendar.length || 0
  let dataDate  = getDate( paramDate, selectn( 'data', scoreboardRes ) )
  
  /* now search calendar for first date >= this */
  for (let i = 0; i < calLen; i++) {
    const loopDateObj = dateFormat.dateToObject( calendar[i] ) || new Date()
    const epochTime = loopDateObj.setHours(0,0,0,0)
    if(epochTime >= dataDate) {
      dataDate = epochTime
      break
    }
  }
  
  return dataDate
}

function getDate( paramDate = '', scoreboardRes = {} ) {
  if( paramDate ) {
    return getParamDate( paramDate )
  }
  return getDataDate( scoreboardRes )
}

function getParamDate( paramDate = '' ) {
  let dateObj = dateFormat.paramToDate( paramDate ) || new Date()
  return dateObj.setHours(0,0,0,0)
}

function getDataDate( scoreboardRes = {} ) {
  let dateStr = selectn( 'day.date', scoreboardRes ) || selectn( 'events[0].date', scoreboardRes ) || ''
  if ( !dateStr ) {
    const d = new Date()
    dateStr = d.toISOString()
  }
  const dateObj = dateFormat.dateToObject( dateStr ) || new Date()
  return dateObj.setHours(0,0,0,0)
}

function getDefaultDate() {
  const dateObj = new Date()
  return dateObj.setHours(0,0,0,0)  
}

function epochToISO( epoch ) {
  const dateObj = new Date( epoch )
  return dateObj.toISOString()
}

/**
 * An Example of calling multiple APIs
 * in series having dependencies
 *
 * @param  {Object}   edition     Edition config
 * @param  {Object}   params      Params
 * @param  {Object}   location    Router location
 * @return {Function}             Handled by thunk middleware
 **/
export default function getSchedule({ edition = {}, params = {}, location = {} }) {

  //console.log('fetching schedule page')
  
  const league          = params.league || ''
  const team            = params.team || ''
  let leagueResults     = {}
  let fixturesResults   = {}
  let displayDate       = getDefaultDate()
  
  if ( league || team ) {
    fixturesResults = {
      data : {
        scores : []
      }
    }
  }
  
  return ( dispatch ) => {
    
    const loadLeagueList = function () {
      
      //console.log('fetching league list')
      
      const leaguesAction = getLeagues({ edition, params, location })
      
      if( !leaguesAction.promise ) {
        //console.log('fetched league list')
        return {}
      }
      
      return leaguesAction.promise
        .then( res => {
          
          //console.log('fetched league list')
          
          leagueResults = res || {}
          
          return res      
          
        })
    }
    
    const loadSchedule = function () {
      
      //console.log('fetching schedule')
      
      if ( league || team ) {
        return loadScoreboard()
      }else{
        return loadScorepanel()
      }
      
    }
    
    const loadScorepanel = function () {
      
      //console.log('fetching scorepanel')

      const fixturesAction = getScoreboard({ edition, params, location })

      return fixturesAction.promise
        .then( res => {
        
          //console.log('fetched scorepanel')
          
          displayDate = getDate( params.date, selectn( 'data.scores[0]', res ) || {})
          fixturesResults = res || {}
          
          return res  
          
        })
      
    }
    
    const loadScoreboard = function ( date = '' ) {
      
      //console.log('fetching scoreboard '+ date)
      
      let linkParams = Object.assign( {}, params )
      if( date ) {
        linkParams.date = date
      }
      
      const fixturesAction = getScoreboard({ edition, params: linkParams, location })

      return fixturesAction.promise
        .then( res => {
        
          //console.log('fetched scoreboard '+ date)          

          const scheduleData = selectn( 'data', res ) || {}

          if (scheduleData.events && scheduleData.events.length > 0 ) {
            fixturesResults.data.scores.push(scheduleData)
          } else if ( scheduleData.scores && scheduleData.scores.length > 0 ) {
            fixturesResults.data.scores = scheduleData.scores
          }
          
          if( !date ) {
            
            displayDate = getDisplayDate( params.date, res )
            
            let minDate = displayDate
            if( params.date ) {
              const paramsDate = getParamDate( params.date ) || 0
              if( paramsDate === displayDate ) {
                minDate = paramsDate + DAY_IN_MILLISECONDS
              }                 
            }else{
              minDate = displayDate + DAY_IN_MILLISECONDS
            }
            
            const altDates  = getAltDates( minDate , res )
            const altLen  = altDates.length || 0
            if(altLen) {
              let promises = []
              for (let i = 0; i < altLen; i++) {
                promises.push(
                  loadScoreboard( altDates[i] )
                )
              }
              return Promise.all(promises)
            }
          }

          return res  
          
        })
      
    }
    
    const dispatchResult = function () {
      
      //console.log('fetched schedule')
      
      function compare( a, b ) {
        let aVal = selectn('events[0].date', a ) || 0
        let bVal = selectn('events[0].date', b ) || 0
        aVal = dateFormat.dateToKey( aVal )
        bVal = dateFormat.dateToKey( bVal )
        if (aVal < bVal) {
          return -1
        }
        if (aVal > bVal) {
          return 1
        }
        return 0
      }

      fixturesResults.data.scores.sort(compare)
      
      dispatch({
        data :    transform.onGetSchedule({ scheduleRes: fixturesResults, leagueRes: leagueResults, displayDate: epochToISO( displayDate ), edition, params, location }),
        type :    actionTypes.GET_FIXTURES
      })
    }
        
    const scheduleFailure = function ( error ) {
      console.log(error)
      //dispatch( getErrorRedirect( params ) )  
      dispatch({
        data :    transform.onGetSchedule({ scheduleRes:{}, leagueRes: [], displayDate: '', edition, params, location }),
        type :    actionTypes.GET_FIXTURES
      })
    }   
    
    return Promise.all( [ loadSchedule(), loadLeagueList() ] )
      .then( dispatchResult )
      .catch( scheduleFailure )
    
  }
}



/** WEBPACK FOOTER **
 ** ../app/actions/api/schedule.js
 **/